import {useFormContext} from '@yandex-delivery/form'
import {useMemo} from 'react'

import {OrderEventGoal, useFormUserEventHandler} from 'src/shared/hooks'
import type {DueSettings, Order} from 'src/shared/types'
import {DeliveryType} from 'src/shared/types'

import {OfferDeliveryType} from './consts'
import {OfferCalculate} from './schema'
import {toGetOffersPayload} from './utils/from-offer-body'

function useOffersBody() {
  const {watch} = useFormContext<Order>()
  const formValues = watch()

  const offerBody = useMemo(() => {
    try {
      const payload = toGetOffersPayload(formValues)
      OfferCalculate.validateSync(payload)

      return payload
    } catch {
      return undefined
    }
  }, [formValues])

  return {
    body: offerBody,
    updateKey: JSON.stringify(offerBody),
  } as const
}

export function useOffers(name: string) {
  const {watch} = useFormContext()
  const {body: offersBody, updateKey} = useOffersBody()
  const handleReachGoal = useFormUserEventHandler()

  const verticalDueSettings: DueSettings | undefined = watch(`${name}.vertical.dueSettings`)
  const isDeliveryIntervalVisible: boolean = watch(`${name}.vertical.name`) === DeliveryType.Night
  const isOrderTimeVisible: boolean = watch(`${name}.deliveryType`) === OfferDeliveryType.ToTime

  function handleDueSelect() {
    handleReachGoal(OrderEventGoal.WhenDueClick)
  }

  return {
    isDeliveryIntervalVisible,
    isOrderTimeVisible,
    verticalDueSettings,
    handleDueSelect,
    offersBody,
    updateKey,
  } as const
}
